import React from 'react';
import { connect } from 'react-redux';
import { removeNotification } from '../../actions/reduxActions/notification';
import { CSSTransitionGroup } from 'react-transition-group';
import Notification from './Notification';

import '../../../css/notification.less';

export const Notifications = ({ notifications, remove }) => {

    // Only ever show a maximum of 5
    const mostRecentNotifications = notifications.slice(-5);

    return (
        <div className="toast-notifications">
            <CSSTransitionGroup transitionName="example" transitionEnterTimeout={600} transitionLeaveTimeout={300}>
                {
                    mostRecentNotifications.map(
                        notification => <Notification key={notification.id} {...notification} onRemove={remove} />,
                    )
                }
            </CSSTransitionGroup>
        </div>
    );
};

const mapStateToProps = ({ notifications }) => ({ notifications });

const mapDispatchToProps = {
    remove: removeNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Notifications);
